import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export class CropService {
  static getCrops(regionId, cityId, salesChannelId) {
    return RetailerApiClient.get(
      'crops?regionId=' + regionId + '&cityId=' + cityId + '&salesChannelId=' + salesChannelId
    )
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
